// Backport from AngularJS (webroot/_ui/desktop/common/js/angular/controllers/cartPageController.js)
import logger from '../utils/rbata.logger';
import urlService from '../services/rbata.urlService';
import personalizeService from '../services/rbata.personalizeService';
import spinner from '../utils/rbata.spinner';
import notifyMeService from '../services/rbata.notifyMeService';
import crossSellingComponent from '../components/rbata.crossSellingComponent';

const cart = {
    $body:              undefined,
    cartButtonObserver: undefined,
    init() {
        this.$body = $('body');
        this.bindEvents();
    },
    proceedToCheckout() {
        spinner.visibility(true);
        setTimeout(() => {
            dataLayer.push(window.alphatauri.tracking.begin_checkout);
        }, 500);
        $.ajax({
            url:    `${urlService.getBaseUrl()}cart/removealloutofstockproducts/`,
            method: 'GET',
            cache:  false
        }).then(() => {
            personalizeService.getPersonalizedData().then((data) => {
                        if (data.loginState === '1') {
                            dataLayer.push(window.alphatauri.tracking.cart);
                        }
                        window.location.href = `${urlService.getBaseUrl()}cart/checkout`;
                    },
                    (jqXHR) => {
                        logger.error(`error in personalizeService, code: ${jqXHR.status}`);
                        window.location.reload();
                    });
        }, (jqXHR) => {
            logger.error(`${jqXHR.status} error in cart.removealloutofstockproducts`);
            window.location.reload();
        });
    },
    removeOutOfStockProduct(productCode) {
        let request = $.ajax({
            url:         `${urlService.getBaseUrl()}cart/removeOutOfStockProduct`,
            method:      'POST',
            contentType: 'application/json',
            data:        JSON.stringify({
                productCode: productCode
            })
        });
        spinner.visibility(true);
        request.always(() => {
            window.location.reload();
        });
    },
    removeClearCartInfoProduct(productCode) {
        let request = $.ajax({
            url:         `${urlService.getBaseUrl()}cart/removeClearCartInfoProduct`,
            method:      'POST',
            contentType: 'application/json',
            data:        JSON.stringify({
                productCode: productCode
            })
        });
        spinner.visibility(true);
        request.always(() => {
            window.location.reload();
        });
    },
    bindEvents() {
        this.$body.on('click', '.js-proceed-to-checkout', (evt) => {
            evt.preventDefault();
            this.proceedToCheckout();
        });
        this.$body.on('click', '.js-notifyme-outofstock-entry', (evt) => {
            evt.preventDefault();
            const productCode = evt.currentTarget.dataset.productCode;

            notifyMeService.showNotifyMeModal(productCode);
        });
        this.$body.on('click', '.js-remove-outofstock-entry', (evt) => {
            evt.preventDefault();
            const productCode = evt.currentTarget.dataset.productCode;
            this.removeOutOfStockProduct(productCode);
        });
        this.$body.on('click', '.js-remove-clear-cart-info-product', (evt) => {
            evt.preventDefault();
            const productCode = evt.currentTarget.dataset.productCode;

            this.removeClearCartInfoProduct(productCode);
        });
    }
};

$(() => {
    if ($('#cart-page').length) {
        cart.init();
        crossSellingComponent.cartInit();
    }
});
